import React, {useState, useEffect} from "react";
import '../styles/DishOfTheDay.css';

function DishOfTheDay({ dishSectionRef }) {

    const [dishes, setDishes] = useState([]);

    useEffect(() => {
        fetch('https://strapi.restauracjasamiswoi.pl/api/obiad-dnias?sort=order:asc')
        .then(response => response.json())
        .then(data => {
            setDishes(data.data);
        });
    }, []);

    return (

        <div className="container-fluid my-5-5 py-5">
            <div className="container">
                <h2 ref={dishSectionRef} className="text-green-light fs-2 fw-semibold mb-1">Obiad dnia - 27zł <span className="fs-5 fw-light">(zupa + drugie danie)</span></h2>
                    <p className="text-green-light p-2"> Wydajemy: PON-PT: 11:00 - 16:00; SOB: 11:00 - 15:00</p>
                    <div className="row">
                        <div className="col-12 col-lg-8">
                            <div className="menu-items-list row">
                                {dishes.map((dish) => (
                                    <div key={dish.id} className="menu-item col-12 col-md-6 mb-4">
                                        <div className="menu-card p-3">
                                            <h5>{dish.dzienTygodnia}</h5>
                                            <p className="text-muted">{dish.Data}</p>
                                            <ul>
                                                {dish.drugieDanie.trim() ?
                                                <>
                                                <li>{dish.Zupa}</li>
                                                <li>{dish.drugieDanie}</li>
                                                </> : <b className="fs-5">{dish.Zupa}</b>}
                                            </ul>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="col-12 col-lg-4 dishes-of-the-day-photo-container">
                            <div className="dishes-of-the-day-photo-background">
                                <img src={require('../assets/photos/daily_dishes.webp')} className="dishes-of-the-day-photo img-hover-zoom img-shadow" />
                            </div>
                        </div>
                    </div>
            </div>
        </div>

    )
}

export default DishOfTheDay;   